export default () => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 16.5C13.5376 16.5 16 14.0376 16 11C16 7.96243 13.5376 5.5 10.5 5.5C7.46243 5.5 5 7.96243 5 11C5 14.0376 7.46243 16.5 10.5 16.5Z"
      stroke="#949494"
      stroke-width="2"
    />
    <path
      d="M15.4141 15.5L19.0001 19.086"
      stroke="#949494"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);
